import React from 'react';

import LazyComponent from 'components/LazyComponent';

const LazyGeneric = ({ importFn, ...props }) => (
    <LazyComponent
        importFn={importFn}
        componentProps={props}
    />
)

export default React.memo(LazyGeneric);
